"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyService = void 0;
const FilterTypings_1 = require("../../Views/Partials/Components/Filters/FilterTypings");
const lists_1 = require("../lists");
const search_1 = require("../search");
const String_utils_1 = require("../String.utils");
const TaxonomyApi_1 = require("./TaxonomyApi");
const taxonomyLoaders_1 = require("./taxonomyLoaders");
const productsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.ProductsTaxonomy,
    priority: 1,
};
const languagesTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.LanguagesTaxonomy,
    priority: 2,
};
const newsCategoriesTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.NewsCategoriesTaxonomy,
    priority: 3,
};
const eventCategoriesTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.EventCategoriesTaxonomy,
    priority: 4,
};
const marketsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.MarketsTaxonomy,
    priority: 7,
};
const downloadTypeTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.DownloadTypeTaxonomy,
    priority: 5,
};
const segmentsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.SegmentsTaxonomy,
    priority: 5,
};
const subSegmentsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.SubSegmentsTaxonomy,
    priority: 5,
};
const brandsDhsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.BrandsDhstaxonomy,
    priority: 8,
};
const brandsDdsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.BrandsDdstaxonomy,
    priority: 9,
};
const solutionsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.SolutionsTaxonomy,
    priority: 10,
};
const applicationsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.ApplicationsTaxonomy,
    priority: 11,
};
const productTypesDdsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.ProductTypesDdstaxonomy,
    priority: 12,
};
const enclosuresDdsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.EnclosuresDdstaxonomy,
    priority: 13,
};
const careersTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.CareersTaxonomy,
    priority: 14,
};
const countriesTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.CountriesTaxonomy,
    priority: 0,
    taxonomyLoader: taxonomyLoaders_1.countryTaxonomyLoader,
};
const megatrendsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.MegatrendsTaxonomy,
    priority: 15,
};
// Set group filter and order in specific pages
const GROUP_FILTER_TEMPLATE_BY_LIST_TYPE = {
    [FilterTypings_1.FilterableListTypeEnum.ProductCategories]: [marketsTemplate, segmentsTemplate],
    [FilterTypings_1.FilterableListTypeEnum.Products]: [
        productsTemplate,
        newsCategoriesTemplate,
        eventCategoriesTemplate,
        Object.assign(Object.assign({}, marketsTemplate), { isCollapsed: true }),
        segmentsTemplate,
        downloadTypeTemplate,
        subSegmentsTemplate,
        solutionsTemplate,
        applicationsTemplate,
        brandsDhsTemplate,
        brandsDdsTemplate,
        productTypesDdsTemplate,
        enclosuresDdsTemplate,
        careersTemplate,
    ],
    [FilterTypings_1.FilterableListTypeEnum.SearchResults]: [segmentsTemplate, downloadTypeTemplate],
    [FilterTypings_1.FilterableListTypeEnum.CaseStudies]: [
        productsTemplate,
        newsCategoriesTemplate,
        eventCategoriesTemplate,
        marketsTemplate,
        segmentsTemplate,
        downloadTypeTemplate,
        subSegmentsTemplate,
        solutionsTemplate,
        applicationsTemplate,
        brandsDhsTemplate,
        brandsDdsTemplate,
        productTypesDdsTemplate,
        enclosuresDdsTemplate,
        careersTemplate,
        megatrendsTemplate,
    ],
    [FilterTypings_1.FilterableListTypeEnum.Downloads]: [
        productsTemplate,
        newsCategoriesTemplate,
        eventCategoriesTemplate,
        marketsTemplate,
        segmentsTemplate,
        downloadTypeTemplate,
        subSegmentsTemplate,
        solutionsTemplate,
        applicationsTemplate,
        brandsDhsTemplate,
        brandsDdsTemplate,
        productTypesDdsTemplate,
        enclosuresDdsTemplate,
        careersTemplate,
    ],
    [FilterTypings_1.FilterableListTypeEnum.News]: [
        productsTemplate,
        newsCategoriesTemplate,
        eventCategoriesTemplate,
        marketsTemplate,
        segmentsTemplate,
        downloadTypeTemplate,
        subSegmentsTemplate,
        solutionsTemplate,
        applicationsTemplate,
        brandsDhsTemplate,
        brandsDdsTemplate,
        productTypesDdsTemplate,
        enclosuresDdsTemplate,
        careersTemplate,
        megatrendsTemplate,
    ],
    [FilterTypings_1.FilterableListTypeEnum.Events]: [
        Object.assign(Object.assign({}, marketsTemplate), { isCollapsed: true }),
        Object.assign(Object.assign({}, segmentsTemplate), { isCollapsed: false }),
        Object.assign(Object.assign({}, eventCategoriesTemplate), { isCollapsed: true }),
        Object.assign(Object.assign({}, languagesTemplate), { isCollapsed: true }),
        Object.assign(Object.assign({}, countriesTemplate), { isCollapsed: true }),
        Object.assign(Object.assign({}, subSegmentsTemplate), { isCollapsed: true }),
        Object.assign(Object.assign({}, megatrendsTemplate), { isCollapsed: true }),
    ],
};
class TaxonomyService {
    static findFacetByTaxonomyGroupItem(taxonomy, facets, ignoreWarnings = false) {
        const matchedFacets = facets.filter(item => {
            const id = (0, lists_1.removePrefix)(item.id, search_1.FACET_PREFIX);
            return (0, String_utils_1.equalIgnoreCase)(id, taxonomy.filterValue);
        });
        const result = matchedFacets && matchedFacets.length > 0 ? matchedFacets[0] : null;
        if (!ignoreWarnings && !result) {
            // tslint:disable-next-line:no-console
            console.error(`Facet for taxonomy group '${taxonomy.filterValue}' not found. Group ignored`);
        }
        return result;
    }
    static findTaxonomyItemByFilterItem(filterItem, taxonomyItems) {
        const matchedTaxonomies = taxonomyItems
            ? taxonomyItems.filter(taxonomy => {
                return taxonomy.value === filterItem.queryValue;
            })
            : null;
        const result = matchedTaxonomies && matchedTaxonomies.length > 0 ? matchedTaxonomies[0] : null;
        if (!result) {
            // tslint:disable-next-line:no-console
            console.error(`Taxonomy item for filter '${filterItem.displayName}' not found`);
        }
        return result;
    }
    static convertToTaxonomyAliases(items) {
        let result = [];
        if (items) {
            result = items.map(item => {
                return item.type;
            });
        }
        return result;
    }
    static convertToPriorityByType(items) {
        let result = {};
        if (items) {
            result = items.reduce((previousValue, currentValue) => {
                const typeAlias = currentValue.type;
                previousValue[typeAlias] = currentValue.priority;
                return previousValue;
            }, {});
        }
        return result;
    }
    static getGroupFilterTemplateByType(type, filterFunction = null) {
        let items = GROUP_FILTER_TEMPLATE_BY_LIST_TYPE[type];
        if (items && filterFunction) {
            items = items.filter(filterFunction);
        }
        return items;
    }
    static getTaxonomyGroupByType(typeAlias, taxonomies) {
        const matchedTaxonomy = taxonomies.filter(taxonomy => taxonomy.typeAlias === typeAlias);
        return (0, lists_1.getFirstOrDefault)(matchedTaxonomy, null);
    }
    static getTranslation(taxonomyGroup, tags) {
        let result = null;
        if (taxonomyGroup && taxonomyGroup.items && tags) {
            result = tags.map(tag => {
                const matchedItems = taxonomyGroup.items
                    .filter(item => {
                    return (0, String_utils_1.equalIgnoreCase)(item.value, tag);
                })
                    .map(item => item.title);
                return (0, lists_1.getFirstOrDefault)(matchedItems, tag);
            });
        }
        return result;
    }
    static getTaxonomyItemByValue(taxonomyGroup, value) {
        let result;
        if (taxonomyGroup && taxonomyGroup.items && value) {
            const matchedItems = taxonomyGroup.items.filter(item => {
                return (0, String_utils_1.equalIgnoreCase)(item.value, value);
            });
            result = (0, lists_1.getFirstOrDefault)(matchedItems, null);
        }
        return result;
    }
}
exports.TaxonomyService = TaxonomyService;
